import React from "react";
import { Input } from "@inspinia-react/form/input";
import { connect } from "react-redux";
import { api, get, getBranchOwner } from "@config";
import { bindActionCreators } from "redux";

import { setPersonDoc } from "@parts/person/actions";
import { notification } from "antd";

import { validateCPF } from "../document-component/validate-cpf";
import { validateCNPJ } from "../document-component/validate-cnpj";
import { mapTest } from "../../pages/products/map.test";
import ImportCNPJ from "../../../_components/ImportCNPJ";
import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber,
} from "../base-person/actions";
import { setCNAE, setFancyName } from "../company-data/actions";
import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "../address-component/actions";

class DocumentComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mask: [
        "999.999.999-99",
        "**.***.***/****-99",
        "**.***.***/****-99",
        "999.999.999-99",
      ],
      documentType: ["CPF", "CNPJ", "CNPJ", "CPF"],
      checkingDoc: false,
    };
    this._onChange = this._onChange.bind(this);
  }

  validate(e) {
    const docComp = document.getElementById("document");
    if(docComp) docComp.setAttribute("validate-error", false);

    const isCompany = ![0, 3].includes(this.props.type);
    const cleanE = typeof e === "string" 
      ? (isCompany ? e.replace(/[^a-zA-Z0-9]/g, "").toUpperCase() : e.replace(/\D/g, ""))
      : e;
    if (isCompany && cleanE.length == 14) {
      if (!validateCNPJ(cleanE)) {
        notification.open({
          message: "CNPJ Invalido",
          type: "error",
          key: "003",
        });
      } else {
        this.searchDoc(cleanE);
      }
    } else if (!isCompany && cleanE.length == 11) {
      if (!validateCPF(cleanE)) {
        notification.open({
          message: "CPF Invalido",
          type: "error",
          key: "004",
        });
      } else {
        this.searchDoc(cleanE);
      }
    }
  }

  _onChange(e) {
    let val = e && e.target ? e.target.value : e;
    this.props.setPersonDoc(val);
    if (!this.props.noValidation) {
      this.validate(val);
    }
  }

  searchDoc(doc) {
    this.setState({ checkingDoc: true });
    const branch = getBranchOwner();
    const branchId = branch ? branch.id : '';
    const isCompany = ![0, 3].includes(this.props.type);
    const cleanDoc = typeof doc === "string" 
      ? (isCompany ? doc.replace(/[^a-zA-Z0-9]/g, "").toUpperCase() : doc.replace(/\D/g, ""))
      : doc;
    const url = `${api.searchCmpanyByCnpj}=${cleanDoc}&type=person&branch_owner=${branchId}`;
    const payload = (data) => {
      this.setState({ checkingDoc: false });

      const docComp = document.getElementById("document");
      if (data.status) {
        docComp.setAttribute("validate-error", true);

        const isCompany = ![0, 3].includes(this.props.type);
        const docLabel = isCompany ? "CNPJ" : "CPF";

        notification.open({
          message: `${docLabel} ja cadastrado`,
          type: "error",
          key: "001",
        });
      } else {
        docComp.setAttribute("validate-error", false);
      }
    };
    get(url, payload, () => this.setState({ checkingDoc: false }));
  }

  render() {
    const { type, doc, required } = this.props;
    const { checkingDoc } = this.state;
    const cnpjLabel = required ? "* CNPJ" : "CNPJ";
    const handleSuccess = (data) => {
      this.props.setBasePersonName(data.name);
      this.props.setBasePersonEmail(data.email);
      this.props.setBasePersonPhoneNumber(data.phone_number);
      this.props.setFancyName(data.company.fancy_name);
      this.props.setPostalCode(data.address.postal_code);
      this.props.setStreetNumber(data.address.street_number);
      this.props.setComplement(data.address.complement);
      this.props.setStateLocation({
        id: data.address.state_location,
        value: data.address.state_location,
        label: data.address.state_location_uf,
      });
      this.props.setCityLocation({
        id: data.address.city_location,
        value: data.address.city_location,
        label: data.address.city_location_name,
      });
      this.props.setStreet(data.address.street);
      this.props.setDistrict(data.address.district);
    };
    return (
      <div>
        {type !== 1 && type !== 2 ? (
          <React.Fragment>
            {required ? "* " : ""}Documento
            <Input
              onChange={this._onChange}
              value={doc}
              id={mapTest.createClient.clientDocumentInput}
              placeholder={`Insira aqui o ${this.state.documentType[type]}`}
              mask={this.state.mask[type]}
              disabled={checkingDoc}
            />
          </React.Fragment>
        ) : (
          <ImportCNPJ 
            onSuccess={handleSuccess} 
            cnpj={doc} 
            type="person" 
            onChange={this._onChange} 
            id={mapTest.createClient.clientDocumentInput}
            label={cnpjLabel}
            disabled={checkingDoc}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  type: state.personType,
  doc: state.personDoc,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPersonDoc,
      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber,
      setCNAE,
      setFancyName,
      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentComponent);



// WEBPACK FOOTER //
// ./src/components/parts/person/document.jsx